"use client";

import React from "react";
import { SidebarNavDropdownItem, SidebarNavItem } from "./SidebarNav.types";
import { SidebarNavBadge } from "./SidebarNavBadge";
import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";

type Props = {
  item: SidebarNavItem;
  collapsed: boolean;
  pathname: string;
  onNavigate: (item: SidebarNavItem | SidebarNavDropdownItem) => void;
};

export const SidebarLinkNavItem: React.FC<Props> = ({ item, collapsed, pathname, onNavigate }) => {
  const active = item.href ? pathname === item.href : false;
  const Icon = item.icon;
  const showCollapsedDot = collapsed && item.badge && !item.badgeRender;
  const highlight = item.highlight ?? item.badge === true;

  const content = (
    <>
      {item.iconRender ? item.iconRender({ active, collapsed }) : Icon ? <Icon className="h-5 w-5" /> : null}
      <span>{item.label}</span>
      {item.badgeRender ? item.badgeRender({ collapsed }) : !collapsed && <SidebarNavBadge badge={item.badge} />}
      {showCollapsedDot && (
        <div className="absolute top-1 right-1 ml-1 h-2 w-2 rounded-full bg-cede-primary shrink-0" />
      )}
    </>
  );

  return (
    <SidebarMenuItem>
      <div className={cn(highlight && "relative overflow-hidden group")}>
        {highlight && (
          <div className="absolute inset-0 rounded-md bg-cede-primary/10 shadow-[inset_0_0_22px_rgba(94,166,255,0.12)] pointer-events-none animate-sidebar-highlight" />
        )}
        <SidebarMenuButton
          asChild={!!item.href}
          onClick={item.onClick ? () => onNavigate(item) : undefined}
          isActive={active}
          disabled={item.disabled}
          tooltip={item.label}
          className={cn(
            highlight && "relative z-10 bg-transparent",
            item.badgeRender && "flex-wrap h-auto min-h-8",
            item.hoverClassName,
            item.activeClassName,
          )}
        >
          {item.href ? (
            <a
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                onNavigate(item);
              }}
            >
              {content}
            </a>
          ) : (
            <>{content}</>
          )}
        </SidebarMenuButton>
      </div>
    </SidebarMenuItem>
  );
};
